<template>
  <div>
    <div class="mt20">
      <spinner-three-bounce :displayNone="!isLoadingB"/>
      <div class="centerText " v-if="isLoadingB">
        <h3>
          Veuillez patienter pendant le chargement de vos données.
        </h3>
        <p>
          Relaxez-vous et prenez une grande inspiration.
        </p>
      </div>
    </div>

    <div v-show="!isLoadingB">
      <!-- detail Virement  -->
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-6">
              <div class="widget no-padding widget-lemonway">
                <div v-if="errorWalletSeller || errorWalletSellerStatus" class="widget red-bg no-padding widget-lemonway">
                  <div class="p-m">
                    <a v-if="this.isCredit" :href="walletInfoCredit.wallet.url" target="_blank" class="link-wallet"><span class="pull-right" title="Accéder aux wallet"><i class="fa fa-pencil"></i></span></a>
                    <a v-else :href="walletInfo.seller.wallet.url" target="_blank" class="link-wallet"><span class="pull-right" title="Accéder aux wallet"><i class="fa fa-pencil"></i></span></a>
                    <div class="row">
                      <div class="col-lg-6">
                        <h3 class="font-bold no-margins">
                          {{ getVirementWallet }}
                        </h3>
                        <h1 v-if="command.paymentMode === 2 || command.paymentMode === 1" class="m-xs">{{ walletInfo.seller.wallet.totalAmount | formatDecimalPrice }} €</h1>
                        <small v-if="command.paymentMode === 2 || command.paymentMode === 1">{{ walletInfo.seller.wallet.message }} <br></small>
                        <h1 v-if="this.isCredit" class="m-xs">{{ walletInfoCredit.wallet.totalAmount | formatDecimalPrice }} €</h1>
                        <small v-if="this.isCredit">{{ walletInfoCredit.wallet.message }}<br></small>
                        <small v-if="command.paymentMode === 2 || command.paymentMode === 1"><i class="fa fa-building"></i> {{ walletInfo.seller.wallet.id.carizy }}</small>
                      </div>
                      <div class="col-lg-6">
                        <div class="text-center">
                          <i class="fa fa-warning fa-4x"></i>
                          <h3 class="m-xs error">{{ errorWalletSeller }} </h3> <br>
                          <h3 v-if="errorWalletSellerStatus" class="m-xs error">{{ errorWalletSellerStatus }} </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="widget navy-bg no-padding widget-lemonway">
                  <div class="p-m">
                    <a v-if="this.isCredit" :href="walletInfoCredit.wallet.url" target="_blank" class="link-wallet"><span class="pull-right" title="Accéder aux wallet"><i class="fa fa-pencil"></i></span></a>
                    <a v-else :href="walletInfo.seller.wallet.url" target="_blank" class="link-wallet"><span class="pull-right" title="Accéder aux wallet"><i class="fa fa-pencil"></i></span></a>
                    <h3 class="font-bold no-margins">
                      {{ getVirementWallet }}
                    </h3>
                    <h1 v-if="command.paymentMode === 2 || command.paymentMode === 1" class="m-xs">{{ walletInfo.seller.wallet.totalAmount | formatDecimalPrice }} €</h1>
                    <small v-if="command.paymentMode === 2 || command.paymentMode === 1">{{ walletInfo.seller.wallet.message }}<br></small>
                    <h1 v-if="this.isCredit" class="m-xs">{{ walletInfoCredit.wallet.totalAmount | formatDecimalPrice }} €</h1>
                    <small v-if="this.isCredit">{{ walletInfoCredit.wallet.message }}<br></small>
                    <small v-if="command.paymentMode === 2 || command.paymentMode === 1"><i class="fa fa-building"></i> {{ walletInfo.seller.wallet.id.carizy }}</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div v-if="errorWalletBuyer || errorWalletBuyerStatus" class="widget red-bg no-padding widget-lemonway">
                <div class="p-m">
                  <a :href="walletInfo.buyer.wallet.url" target="_blank" class="link-wallet"><span class="pull-right" title="Accéder aux wallet"><i class="fa fa-pencil"></i></span></a>
                  <div class="row">
                    <div class="col-lg-6">
                      <h3 class="font-bold no-margins">
                        {{ getVirementLabel }}
                      </h3>
                      <h1 class="m-xs">
                        {{ walletInfo.buyer.wallet.totalAmount | formatDecimalPrice }} €
                      </h1>
                      <small>{{ walletInfo.buyer.wallet.message }}</small>
                    </div>
                    <div class="col-lg-6">
                      <div class="text-center">
                        <i class="fa fa-warning fa-4x"></i>
                        <h3 class="m-xs error">{{ errorWalletBuyer }} </h3>
                        <h3 v-if="errorWalletBuyerStatus" class="m-xs error">{{ errorWalletBuyerStatus }} </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="widget no-padding widget-lemonway" :class="warningWalletBuyer === false ? 'navy-bg' : 'yellow-bg'">
                <div class="p-m">
                  <a :href="walletInfo.buyer.wallet.url" target="_blank" class="link-wallet"><span class="pull-right" title="Accéder aux wallet"><i class="fa fa-pencil"></i></span></a>
                  <div class="col-lg-6">
                    <h3 class="font-bold no-margins">
                      {{ getVirementLabel }}
                    </h3>
                    <h1 class="m-xs">
                      {{ walletInfo.buyer.wallet.totalAmount | formatDecimalPrice }} €
                    </h1>
                    <small>{{ walletInfo.buyer.wallet.message }}</small>
                  </div>
                  <div class="col-lg-6" v-if="warningWalletBuyer === true">
                    <div class="text-center">
                      <i class="fa fa-bell fa-4x"></i>
                      <h3 class="m-xs error">Solde wallet supérieur à la commande</h3>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- fin lemonway  -->
      <Accordion title="Détail de la commande" titleIcon="fa fa-usd">
        <template slot="content">
          <div class="row">
            <div class="col-lg-12">
              <div>
                <div class="row">
                  <div class="col-sm-6">
                    <h4>Commande : <span class="text-navy"> <strong>#{{ commandId }} </strong></span></h4>
                    <h4>Créée le&nbsp;: <span class="text-navy"><strong>{{ command.creationDate | formatDate }}</strong></span></h4>
                    <h4>Moyen de paiement : <strong class="text-navy">{{ getPaymentLabel }}</strong></h4>
                    <h4 class="statuCmd">Status : <strong> <component-status :status="command.status"></component-status> </strong> </h4>
                  </div>
                </div>

                <div class="table-responsive m-t">
                  <table class="table invoice-table table-striped">
                    <tbody>
                    <tr>
                      <td>
                        <div class="table-lemonway">
                          <p>{{ this.vehicle.make }} {{ this.vehicle.version }}</p>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.buyerPrice | formatDecimalPrice }} €</td>
                    </tr>
                    <tr class="make">
                      <td class="make-list">
                        <div>
                          <strong>Dont net vendeur</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.sellerPrice | formatDecimalPrice }} €</td>
                    </tr>
                    <tr class="make">
                      <td class="make-list">
                        <div>
                          <strong>Dont commision</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.saleCommission | formatDecimalPrice }} €</td>
                    </tr>
                    <tr v-if="options.disposalType">
                      <td>
                        <div>
                          <strong>{{ getDisposalLabel }}</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.deliveryPrice | formatDecimalPrice }} €</td>
                    </tr>
                    <tr v-if="warrantyOptions.length && options.warranty">
                      <td>
                        <div class="table-lemonway">
                          <p>{{ getWarrantyLabel }}</p>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.warranty.price | formatDecimalPrice }} €</td>
                    </tr>
                    <tr>
                      <td>
                        <div>
                          <strong>Carte Grise</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.registrationCertificatePrice | formatDecimalPrice }} €</td>
                    </tr>
                    <tr v-if="orderInfo.carRegistrationDocumentEcoTaxPrice !== 0">
                      <td>
                        <div>
                          <strong>Dont écotaxe</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.carRegistrationDocumentEcoTaxPrice | formatDecimalPrice }} €</td>
                    </tr>
                    <tr>
                      <td>
                        <div>
                          <strong>Immatriculation</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.registrationPrice | formatDecimalPrice }} €</td>
                    </tr>
                    <tr>
                      <td>
                        <div>
                          <strong>Frais De Réservation</strong>
                        </div>
                      </td>
                      <td class="text-navy">{{ orderInfo.feesPrice | formatDecimalPrice }} €</td>
                    </tr>

                    </tbody>
                  </table>
                </div><!-- /table-responsive -->

                <table class="table invoice-total">
                  <tbody>
                  <tr class="total">
                    <td><strong>TOTAL DÛ :</strong></td>
                    <td class="text-navy">{{ orderInfo.totalAmount | formatDecimalPrice }} €</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </template>
      </Accordion>
      <div class="row diac-lemonway">
        <div class="col-lg-12">
          <div class="ibox">
            <div class="ibox-title">
              <h5><i class="fa fa-credit-card-alt"></i> Virement</h5>
            </div>
            <div class="ibox-content">
              <div v-if="this.isCredit" class="owner-wizard">
                <ul class="steps">
                  <li v-for="(step, index) in stepCredit"
                      :key="index"
                      :class="[index + 1 === activeStep ? 'active' : 'allowed']"
                      @click="toggleBlock(index + 1)">{{ index + 1 }}. {{ step }}</li>
                </ul>
                <component
                    :getTotalAmount="getTotalAmount"
                    :isvalidSeller="walletInfo.seller.wallet.isValid"
                    :isvalidBuyer="walletInfo.buyer.wallet.isValid"
                    :getWalletBuyerAmount="getWalletBuyerAmount"
                    :is="componentDiac"
                    :status="command.status"
                    :paymentMode="command.paymentMode"
                    :statuSaller="walletInfo.seller.wallet.status"
                    :statuBuyer="walletInfo.buyer.wallet.status"
                    :walletVdr="getVirementWallet"
                    :walletAct="getVirementLabel"
                    :orderId="commandId"
                    :customerId="buyer.id"
                />
              </div>
              <div v-else class="owner-wizard">
                <ul class="steps">
                  <li v-for="(step, index) in steps"
                      :key="index"
                      :class="[index + 1 === activeStep ? 'active' : 'allowed']"
                      @click="toggleBlock(index + 1)">{{ index + 1 }}. {{ step }}</li>
                </ul>
                <component
                    :getTotalAmount="getTotalAmount"
                    :getNetVendeurAmount="getNetVendeurAmount"
                    :getTotalAmountForCheque="getTotalAmountForCheque"
                    :isvalidSeller="walletInfo.seller.wallet.isValid"
                    :isvalidBuyer="walletInfo.buyer.wallet.isValid"
                    :getWalletSellerAmount="getWalletSellerAmount"
                    :getWalletBuyerAmount="getWalletBuyerAmount"
                    :is="component"
                    :status="command.status"
                    :paymentMode="command.paymentMode"
                    :statuSaller="walletInfo.seller.wallet.status"
                    :statuBuyer="walletInfo.buyer.wallet.status"
                    :walletVdr="getVirementWallet"
                    :walletAct="getVirementLabel"
                    :getPaymentLabel="getPaymentLabel"
                    :orderId="commandId"
                    :customerId="buyer.id"
                    :sellerMessageStatus="walletInfo.seller.wallet.message"
                    :buyerMessageStatus="walletInfo.buyer.wallet.message"
                    :idCustomerSeller = "walletInfo.seller.wallet.id.customer"
                    :idCustomerBuyer = "walletInfo.buyer.wallet.id.customer"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import Controle from '../../components/details/lemonway/Controle'
import VirementExterne from '../../components/details/lemonway/VirementExterne'
import VirementP2p from '../../components/details/lemonway/VirementP2p'
import VirementP2pDiac from '../../components/details/lemonway/VirementP2pDiac'
import {appointmentMode, paymentMode} from '@/helpers/utils/constants'
import Status from "@/components/details/Status.vue"
import Alert from '../../components/Alert.vue'
import SpinnerThreeBounce from '@/components/spinners/SpinnerThreeBounce'
import Accordion from '@/components/accordion/accordion'
import { isAddressIncompleteMixin } from '@/mixins/isAddressIncompleteMixin'
import store from "@/config/store";
import WarrantyOptionList from "@/api/query/WarrantyOptionList.gql";

const BANK_CHECK_PAYMENT_MODE = paymentMode.BANK_CHECK_PAYMENT_MODE
const TRANSFER_PAYMENT_MODE = paymentMode.TRANSFER_PAYMENT_MODE
const CREDIT_PAYMENT_MODE_MOBILIZE = paymentMode.CREDIT_PAYMENT_MODE_MOBILIZE
const CREDIT_PAYMENT_MODE_COFIDIS = paymentMode.CREDIT_PAYMENT_MODE_COFIDIS
const CREDIT_PAYMENT_MODE_YOUNITED = paymentMode.CREDIT_PAYMENT_MODE_YOUNITED

export default {
  name: "Virement",

  props: {
    command: {
      type: Object,
      required: true
    },
  },

  components: {
    'component-alert': Alert,
    'component-status': Status,
    SpinnerThreeBounce,
    Accordion,
    'controle': Controle,
    'virementExterne': VirementExterne,
    'virementP2p': VirementP2p,
    'VirementP2pDiac': VirementP2pDiac
  },

  mixins: [isAddressIncompleteMixin],

  data: () => ({
    blocks: [
      'controle',
      'virementP2p',
      'virementExterne'
    ],
    blockDiac: [
      'VirementP2pDiac',
    ],
    steps: [
      'Contrôles',
      'Virement P2P',
      'Virement Externe'
    ],
    stepCredit: [
      'Virement P2P',
    ],
    activeStep: 1,
    paymentMode: {
      BANK_CHECK_PAYMENT_MODE: BANK_CHECK_PAYMENT_MODE,
      TRANSFER_PAYMENT_MODE: TRANSFER_PAYMENT_MODE,
      CREDIT_PAYMENT_MODE_MOBILIZE: CREDIT_PAYMENT_MODE_MOBILIZE,
      CREDIT_PAYMENT_MODE_COFIDIS: CREDIT_PAYMENT_MODE_COFIDIS,
      CREDIT_PAYMENT_MODE_YOUNITED: CREDIT_PAYMENT_MODE_YOUNITED
    },
    walletInfo: {
      seller: {
        wallet: {
          status: "",
          isValid: "",
          totalAmount: "",
          message: "",
          url: "",
          id: {
            carizy: "",
            lemonway: "",
            customer: ""
          }
        }
      },
      buyer: {
        wallet: {
          status: "",
          isValid: "",
          totalAmount: "",
          message: "",
          url: "",
          id: {
            carizy: "",
            lemonway: "",
            customer: ""
          }
        }
      },
    },
    walletInfoCredit: {
      wallet: {
        status: "",
        isValid: "",
        totalAmount: "",
        message: "",
        url: "",
        id: {
          carizy: "",
          lemonway: ""
        }
      }
    },
    orderInfo: {
      warranty: {
        label: "",
        price: 0,
      },
      delivery: {
        address: "",
        zipCode: "",
        city: "",
      },
      deliveryPrice: 0,
      paymentMode: "",
      feesPrice: "",
      registrationCertificatePrice: 0,
      carRegistrationDocumentEcoTaxPrice: 0,
      registrationPrice: 0,
      receivedAmount: "",
      totalAmount: "",
      remainingAmount: "",
      saleCommission: "",
      overAmount: "",
      buyerPrice: "",
      sellerPrice: "",
      changeOptionsAmount: "",
      totalOperationAmount: "",
      totalAmountForCheque: ""
    },
    delivery: {
      isDelivery: false,
      address: {
        address: "",
        city: "",
        zipCode: ""
      },
      coordinate: {
        start: {
          latitude: null,
          longitude: null,
        },
        end: {
          latitude: null,
          longitude: null,
        }
      }
    },
    warrantyOptions: [],
    options: {
      warranty: null,
      payment: null,
      disposalType: null
    },
    customersBalanceDiacQueryisLoadingB: false,
    customersBalanceQueryisLoadingB: false,
    getOrderInformationQueryisLoadingB: false,
    fromBO: true,
    zip: null
  }),

  computed: {
    adSupplier () {
      return this.command.ad.supplier
    },
    isVenteDirect () {
      return this.adSupplier === 'renault'
    },
    getWarrantyLabel () {
      return this.orderInfo.warranty.label
    },
    getDisposalLabel () {
      switch (this.options.disposalType) {
        case appointmentMode.DELIVERY:
          return 'Livraison'
        case appointmentMode.DISPOSAL:
          return 'Rendez-vous de cession'
        default:
          return ''
      }
    },
    getTotalAmount () {
      return this.orderInfo.totalAmount
    },
    getNetVendeurAmount () {
      return this.orderInfo.sellerPrice
    },
    getTotalAmountForCheque() {
      return this.orderInfo.totalAmountForCheque
    },
    getWalletBuyerAmount () {
      return this.walletInfo.buyer.wallet.totalAmount
    },
    getWalletSellerAmount () {
      return this.walletInfo.seller.wallet.totalAmount
    },
    component () {
      return this.blocks[this.activeStep - 1]
    },
    componentDiac () {
      return this.blockDiac[this.activeStep - 1]
    },
    getVirementLabel () {
      return 'Wallet Acheteur'
    },
    getVirementWallet () {
      switch (this.command.paymentMode) {
        case paymentMode.CREDIT_PAYMENT_MODE_MOBILIZE:
          return 'Wallet Mobilize'
        case paymentMode.CREDIT_PAYMENT_MODE_COFIDIS:
          return 'Wallet Cofidis'
        case paymentMode.CREDIT_PAYMENT_MODE_YOUNITED:
          return 'Wallet Younited'
        default:
          return 'Wallet Vendeur'
      }
    },
    getPaymentLabel () {
      switch (this.options.payment) {
        case paymentMode.TRANSFER_PAYMENT_MODE:
          return 'Virement bancaire'
        case paymentMode.BANK_CHECK_PAYMENT_MODE:
          return 'Chèque de banque'
        case paymentMode.CREDIT_PAYMENT_MODE_MOBILIZE:
          return 'Crédit MOBILIZE'
        case paymentMode.CREDIT_PAYMENT_MODE_COFIDIS:
          return 'Crédit COFIDIS'
        case paymentMode.CREDIT_PAYMENT_MODE_YOUNITED:
          return 'Crédit YOUNITED'
        default:
          return ''
      }
    },
    isLoadingB () {
      if (
          this.customersBalanceDiacQueryisLoadingB ||
          this.customersBalanceQueryisLoadingB ||
          this.getOrderInformationQueryisLoadingB
      ) {
        return true
      } else {
        return false
      }
    },
    zipCode () {
      return this.delivery.address.zipCode;
    },
    commandId () {
      return this.$route.params.id
    },
    vehicle () {
      return this.command.vehicule[0]
    },
    buyer () {
      return this.command.buyer[0]
    },
    warningWalletBuyer () {
      let walleterror = false
      if (this.getPaymentLabel === 'Chèque de banque'){
        if (this.walletInfo.buyer.wallet.totalAmount < this.orderInfo.totalAmountForCheque) walleterror = true
      }else if (this.walletInfo.buyer.wallet.totalAmount > this.orderInfo.totalAmount) walleterror = true

      return walleterror
    },
    errorWalletSeller () {
      let walleterror = ""
      if (this.isCredit) {
        if (this.walletInfoCredit.wallet.status === 0)
          walleterror = "Aucun wallet trouvé"
        else if (this.walletInfoCredit.wallet.isValid === false)
          walleterror = "Vérifier le statut du wallet"
        else if (this.walletInfo.buyer.wallet.totalAmount < this.orderInfo.totalAmount) {
          let Sold = this.orderInfo.totalAmount - this.walletInfo.buyer.wallet.totalAmount
          if (this.walletInfoCredit.wallet.totalAmount < Sold) walleterror = "Solde du wallet est inférieur au montant du virement à réaliser"
        }
        //Vérification si le wallet est superieur au montant du virement
      } else {
        if (this.walletInfo.seller.wallet.status === 0) walleterror = "Aucun wallet trouvé"
        else if (this.walletInfo.seller.wallet.isValid === false) walleterror = "Vérifier le statut du wallet"
      }
      return walleterror
    },
    errorWalletBuyer () {
      let walleterror = ""
      if (this.walletInfo.buyer.wallet.status === 0) walleterror = "Aucun wallet trouvé"
      else {
        if (this.getPaymentLabel === 'Chèque de banque'){
          if (this.walletInfo.buyer.wallet.totalAmount < this.orderInfo.totalAmountForCheque & this.walletInfo.buyer.wallet.isValid === false) walleterror = "Solde wallet inférieur à la commande"
          else if (this.walletInfo.buyer.wallet.totalAmount < this.orderInfo.totalAmountForCheque) walleterror = "Solde wallet inférieur à la commande"
          else if (this.walletInfo.buyer.wallet.isValid === false)  walleterror = "Vérifier le statut du wallet"

        } else {
          if (this.walletInfo.buyer.wallet.totalAmount < this.orderInfo.totalAmount & this.walletInfo.buyer.wallet.isValid === false) walleterror = "Solde wallet inférieur à la commande"
          else if (this.walletInfo.buyer.wallet.totalAmount < this.orderInfo.totalAmount) walleterror = "Solde wallet inférieur à la commande"
          else if (this.walletInfo.buyer.wallet.isValid === false) walleterror = "Vérifier le statut du wallet"
        }
      }
      return walleterror
    },
    errorWalletBuyerStatus () {
      let walleterrorStatus = ""
      if (this.walletInfo.buyer.wallet.status !== 0 ) {
        if (this.walletInfo.buyer.wallet.status !== 5 && this.walletInfo.buyer.wallet.status !== 6 && this.walletInfo.buyer.wallet.status !== 16) {
          walleterrorStatus = "Statut du wallet doit être à KYC 1, KYC 2 ou Client occasionnel"
        }
      }
      return walleterrorStatus
    },
    errorWalletSellerStatus () {
      let walleterrorStatus = ""
      if (this.isCredit) {
        if (this.walletInfoCredit.wallet.status !== 0)
          if (this.walletInfoCredit.wallet.status !== 6) walleterrorStatus = "Statut du wallet doit être à KYC 2"
      } else if (this.getPaymentLabel === 'Chèque de banque'){
        if (this.walletInfo.seller.wallet.status === 10) walleterrorStatus = "Wallet status Bloqué"
      } else {
        if (this.walletInfo.seller.wallet.status !== 0 ) {
          if (this.walletInfo.seller.wallet.status !== 6) walleterrorStatus = "Statut du wallet doit être à KYC 2"
        }
      }
      return walleterrorStatus
    },
    isCredit () {
      let mode = [3, 4, 5]
      return mode.includes(this.command.paymentMode)
    }
  },

  OrderInformationQuery () {
    this.$apollo.query({
      query: this.getOrderInformationQuery
    }).then((response) => {
      if (response.data.checkPromoCode.isValid) this.errorWallet = response.data.checkPromoCode
      else {
        this.codePromo.details = null
        this.showBanner('danger', `Le code promo indiqué n'est pas valide`)
      }
    })
  },

  async created () {
    this.zip = this.command.zip
    if (this.command.options !== null) {
      this.command.options.map((x) => {
        if (x.type === "warranty") this.options.warranty = x.id
        if (x.type === "immatriculation") this.options.registration = x.id
        if (x.type === "immatriculationDocument") this.options.carRegistrationDocument = x.id
      })
    }
    await this.getOrderInformationQuery()
    if (this.isCredit) await this.getCustomersBalanceDiacQuery()

    await this.getCustomersBalanceQuery()
    this.options.warranty = this.command.options[0].id
    this.options.disposalType = this.command.delivery ? appointmentMode.DELIVERY : appointmentMode.DISPOSAL
    this.options.payment = this.command.paymentMode
    if (this.options.disposalType === appointmentMode.DELIVERY) {
      this.delivery.isDelivery = true;
    }
    if (this.command.promoCode) {
      this.codePromo.details = this.command.promoCode
    }
    store.order.id = this.$route.params.id
  },

  methods: {
    toggleBlock (step) {
      this.activeStep = step
    },
    async getOrderInformationQuery () {
      this.getOrderInformationQueryisLoadingB = true
      let isRegistrationDocument = this.options.carRegistrationDocument ? true : false
      let isRegistration = this.options.registration ? true : false
      const orderInfo = await this.$apollo.query({
        query: gql`
                    query {
                     getOrderInformation (orderId: ${this.commandId}, warranty: ${this.options.warranty}, paymentMode: ${this.options.payment}, isDelivery: "${this.delivery.isDelivery}",
                      isRegistrationDocument: "${isRegistrationDocument}",
                      isRegistration: "${isRegistration}",
                      zip: "${this.zip}",
                      delivery: {
                          address: "${this.delivery.address.address}",
                          zipCode: "${this.delivery.address.zipCode}",
                          city: "${this.delivery.address.city}",
                          coordinate: {
                              start: {
                                  latitude: ${this.delivery.coordinate.start.latitude},
                                  longitude: ${this.delivery.coordinate.start.longitude},
                              },
                              end: {
                                  latitude: ${this.delivery.coordinate.end.latitude},
                                  longitude: ${this.delivery.coordinate.end.longitude},
                              }
                          }
                        }
                        ) {
                        warranty { label price}
                        deliveryPrice
                        paymentMode
                        feesPrice
                        registrationCertificatePrice
                        carRegistrationDocumentEcoTaxPrice
                        receivedAmount
                        totalAmount
                        remainingAmount
                        saleCommission
                        overAmount
                        buyerPrice
                        sellerPrice
                        changeOptionsAmount
                        totalOperationAmount
                        totalAmountForCheque
                        carRegistrationDocumentPrice
                        carRegistrationPrice
                    }
              }`,
        fetchPolicy: 'no-cache'
      })

      this.orderInfo.warranty.label = orderInfo.data.getOrderInformation.warranty.label
      this.orderInfo.warranty.price = orderInfo.data.getOrderInformation.warranty.price ? orderInfo.data.getOrderInformation.warranty.price : 0
      this.orderInfo.deliveryPrice = orderInfo.data.getOrderInformation.deliveryPrice
      this.orderInfo.paymentMode = orderInfo.data.getOrderInformation.paymentMode
      this.orderInfo.feesPrice = orderInfo.data.getOrderInformation.feesPrice
      this.orderInfo.registrationCertificatePrice = orderInfo.data.getOrderInformation.carRegistrationDocumentPrice
      this.orderInfo.carRegistrationDocumentEcoTaxPrice = orderInfo.data.getOrderInformation.carRegistrationDocumentEcoTaxPrice
      this.orderInfo.registrationPrice =  orderInfo.data.getOrderInformation.carRegistrationPrice
      this.orderInfo.receivedAmount = orderInfo.data.getOrderInformation.receivedAmount
      this.orderInfo.totalAmount = orderInfo.data.getOrderInformation.totalAmount
      this.orderInfo.remainingAmount = orderInfo.data.getOrderInformation.remainingAmount
      this.orderInfo.saleCommission = orderInfo.data.getOrderInformation.saleCommission
      this.orderInfo.overAmount = orderInfo.data.getOrderInformation.overAmount
      this.orderInfo.buyerPrice = orderInfo.data.getOrderInformation.buyerPrice
      this.orderInfo.sellerPrice = orderInfo.data.getOrderInformation.sellerPrice
      this.orderInfo.changeOptionsAmount = orderInfo.data.getOrderInformation.changeOptionsAmount
      this.orderInfo.totalOperationAmount = orderInfo.data.getOrderInformation.totalOperationAmount
      this.orderInfo.totalAmountForCheque = orderInfo.data.getOrderInformation.totalAmountForCheque

      this.getOrderInformationQueryisLoadingB = false

    },
    async getCustomersBalanceDiacQuery () {
      this.customersBalanceDiacQueryisLoadingB = true

      const walletInfoCredit = await this.$apollo.query({
        query: gql`
               query {
                     getCreditBalance(wallet: ${this.command.paymentMode}) {
                        wallet {
                           status,
                           isValid,
                           totalAmount,
                           message,
                           url,
                           id {
                             carizy,
                             lemonway
                           }
                        }
                    }
              }`,
        fetchPolicy: 'no-cache'
      })

      this.walletInfoCredit.wallet.status = walletInfoCredit.data.getCreditBalance.wallet.status
      this.walletInfoCredit.wallet.isValid = walletInfoCredit.data.getCreditBalance.wallet.isValid
      this.walletInfoCredit.wallet.totalAmount = walletInfoCredit.data.getCreditBalance.wallet.totalAmount
      this.walletInfoCredit.wallet.url = walletInfoCredit.data.getCreditBalance.wallet.url
      this.walletInfoCredit.wallet.message = walletInfoCredit.data.getCreditBalance.wallet.message
      this.walletInfoCredit.wallet.id.carizy = walletInfoCredit.data.getCreditBalance.wallet.id.carizy
      this.walletInfoCredit.wallet.id.lemonway = walletInfoCredit.data.getCreditBalance.wallet.id.lemonway

      this.customersBalanceDiacQueryisLoadingB = false

    },
    async getCustomersBalanceQuery () {
      this.customersBalanceQueryisLoadingB = true

      const walletInfo = await this.$apollo.query({
        query: gql`
                    query {
                     getCustomersBalance (
                        orderId: ${this.commandId}
                        ) {
                        seller {
                            wallet {
                                status,
                                isValid,
                                totalAmount,
                                message,
                                url,
                                id {
                                    carizy,
                                    lemonway,
                                    customer

                                }
                            }
                        }
                        buyer {
                            wallet {
                                status,
                                isValid,
                                totalAmount,
                                message,
                                url,
                                id {
                                    carizy,
                                    lemonway,
                                    customer

                                }
                            }
                        }
                    }
              }`,
        fetchPolicy: 'no-cache'
      })

      this.walletInfo.seller.wallet.status = walletInfo.data.getCustomersBalance.seller.wallet.status
      this.walletInfo.seller.wallet.isValid = walletInfo.data.getCustomersBalance.seller.wallet.isValid
      this.walletInfo.seller.wallet.totalAmount = walletInfo.data.getCustomersBalance.seller.wallet.totalAmount
      this.walletInfo.seller.wallet.message = walletInfo.data.getCustomersBalance.seller.wallet.message
      this.walletInfo.seller.wallet.url = walletInfo.data.getCustomersBalance.seller.wallet.url
      this.walletInfo.seller.wallet.id.carizy = walletInfo.data.getCustomersBalance.seller.wallet.id.carizy
      this.walletInfo.seller.wallet.id.lemonway = walletInfo.data.getCustomersBalance.seller.wallet.id.lemonway
      this.walletInfo.seller.wallet.id.customer = walletInfo.data.getCustomersBalance.seller.wallet.id.customer
      this.walletInfo.buyer.wallet.status = walletInfo.data.getCustomersBalance.buyer.wallet.status
      this.walletInfo.buyer.wallet.isValid = walletInfo.data.getCustomersBalance.buyer.wallet.isValid
      this.walletInfo.buyer.wallet.totalAmount = walletInfo.data.getCustomersBalance.buyer.wallet.totalAmount
      this.walletInfo.buyer.wallet.message = walletInfo.data.getCustomersBalance.buyer.wallet.message
      this.walletInfo.buyer.wallet.url = walletInfo.data.getCustomersBalance.buyer.wallet.url
      this.walletInfo.buyer.wallet.id.carizy = walletInfo.data.getCustomersBalance.buyer.wallet.id.carizy
      this.walletInfo.buyer.wallet.id.lemonway = walletInfo.data.getCustomersBalance.buyer.wallet.id.lemonway
      this.walletInfo.buyer.wallet.id.customer = walletInfo.data.getCustomersBalance.buyer.wallet.id.customer

      this.customersBalanceQueryisLoadingB = false

    },
  },

  apollo: {
    warrantyOptions: {
      query: WarrantyOptionList,
      variables () {
        return {
          orderId: this.commandId,
          fromBO: this.fromBO
        }
      },
    }
  }
}
</script>
